import { useRef, useState, useEffect } from "react";
import welcome1Img from "../../content/img/welcome1.png";
import welcome2Img from "../../content/img/welcome2.png";
import welcome3Img from "../../content/img/welcome3.png";
import { useTranslation } from "react-i18next";
import { StepperModal } from "@etframework/ui.components";
import useModalEvent from "../../hooks/useModalEvent";
import { useNavigate } from "react-router-dom";

export const WelcomeModal = ({ isFirstTime = false, modalOpen = false }) => {
  const { t } = useTranslation(["WelcomePage"]);
  const [step, setStep] = useState(0);
  const [showModal, setShowModal] = useState(modalOpen);
  const stepperModalRef = useRef(null);
  const { ModalEvents, useRegisterEvent } = useModalEvent();
  const navigate = useNavigate();

  // Stepper
  const onNextStep = () => {
    setStep((prev) => prev + 1);
  };

  const onNextStepClick = (nextStep) => {
    setStep((prev) => prev + 1);
    stepperModalRef.current?.stepperRef()?.goToStep(nextStep);
  };

  const onPreviousStep = () => {
    setStep((prev) => prev - 1);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const openModal = () => {
    setShowModal(true);
  };

  const onExploreDueDates = () => {
    navigate("/duedates/views/assignedtome");
  };

  const toggleModal = () => {
    if (showModal) {
      closeModal();
      return;
    } else {
      openModal();
    }
  };

  const onSubmit = () => {
    if (isFirstTime) {
      onExploreDueDates();
    }
    stepperModalRef.current.goToStep.current?.(0);
    setStep(0);
    closeModal();
  };

  useEffect(() => {
    if (step == 0) {
      stepperModalRef.current?.stepperRef()?.setShowButtons(false);
    } else {
      stepperModalRef.current?.stepperRef()?.setShowButtons(true);
    }
  }, [step]);

  useRegisterEvent(ModalEvents.WelcomeModal, toggleModal);

  return (
    <StepperModal
      id={ModalEvents.WelcomeModal.Id}
      backdrop="none"
      ref={stepperModalRef}
      isModal
      showCloseIcon={true}
      visible={showModal}
      onNextStep={onNextStep}
      backText={t("Back")}
      continueText={t("Continue")}
      createText={t("ExploreDueDates")}
      onPreviousStep={onPreviousStep}
      onSubmit={onSubmit}
      close={onSubmit}
      minHeight={"20vh"}
      height="600px"
      width="800px"
      steps={[
        {
          id: "welcome-step-one",
          component: (
            <>
              <div className="welcome-header-step">
                <img
                  src={welcome1Img}
                  alt="Welcome illustration"
                  className="welcome-image1"
                />
              </div>
              <div className="welcome-content-step mt-5">
                <span className="welcome-title my-3">{t("WelcomeTitle1")}</span>
                <span className="welcome-message">{t("WelcomeMessage1")}</span>
                <button
                  onClick={() => {
                    onNextStepClick(1);
                  }}
                  className="btn btn-primary w-auto welcome-button mt-5"
                >
                  {t("SeeWhatsNew")}
                </button>
              </div>
            </>
          )
        },
        {
          id: "welcome-step-two",
          component: (
            <>
              <div className="welcome-header-step">
                <img
                  src={welcome2Img}
                  alt="Welcome illustration"
                  className="welcome-image2"
                />
              </div>
              <div className="welcome-content-step mt-5">
                <span className="welcome-title my-3">{t("WelcomeTitle2")}</span>
                <p className="welcome-message">{t("WelcomeMessage2")}</p>
              </div>
            </>
          )
        },
        {
          id: "welcome-step-three",
          component: (
            <>
              <div className="welcome-header-step">
                <img
                  src={welcome3Img}
                  alt="Welcome illustration"
                  className="welcome-image3"
                />
              </div>
              <div className="welcome-content-step mt-5">
                <span className="welcome-title my-3">{t("WelcomeTitle3")}</span>
                <p className="welcome-message">{t("WelcomeMessage3")}</p>
                <div className="mt-4 disclaimer">
                  <div className="m-3">
                    <div className="fw-bold">{t("LegalDisclaimerTitle")}</div>
                    <div>{t("LegalDisclaimerMessage")}</div>
                  </div>
                </div>
              </div>
            </>
          )
        }
      ]}
    />
  );
};
